import { createContext, useState } from 'react';
import { generateAdjustmentsObject } from './Adjustments/utils';
import { getBusinessPartnerDefaults } from '../api/businessPartner';

export const StoreContext = createContext(null);

const StoreProvider = ({ children }) => {
  const [storeTest, setStoreTest] = useState('Gethin');
  const [requestFailed, setRequestFailed] = useState(false);
  const [saved, setSaved] = useState('');
  const [selectName, setSelectName] = useState('');
  const [selectFcl, setSelectFcl] = useState('');
  const [truck, setTruck] = useState('');
  const [trailer, setTrailer] = useState('');
  const [shipStatus, setShipStatus] = useState('');
  const [date, setdate] = useState('');
  const [jobRef, setJobRef] = useState('');
  const [jiraTicket, setJiraTicket] = useState('');
  const [portalRef, setPortalRef] = useState('');
  const [loadTypeDescription, setLoadTypeDescription] = useState('');
  const [loadStatus, setLoadStatus] = useState('');
  const [consignor, setConsignor] = useState('');
  const [consignee, setConsignee] = useState('');
  const [consignorRPA, setConsignorRPA] = useState('');
  const [consigneeRPA, setConsigneeRPA] = useState('');
  const [invoicenumber, setInvoicenumber] = useState('');
  const [poNumber, setPoNumber] = useState('');
  const [invoicecurr, setInvoicecurr] = useState('');
  const [directionLoading, setDirectionLoading] = useState(true);
  const [direction, setDirection] = useState('');
  const [despatch, setDespatch] = useState('');
  const [destination, setDestination] = useState('');
  const [directionSelected, setDirectionSelected] = useState('');
  const [destinationSelected, setDestinationSelected] = useState('');
  const [despatchSelected, setDespatchSelected] = useState('');
  const [despatchLoading, setDespatchLoading] = useState(true);
  const [destinationLoading, setDestinationLoading] = useState(true);
  const [exitLoading, setExitLoading] = useState(true);
  const [entryLoading, setEntryLoading] = useState(true);
  const [incotermLoading, setIncotermLoading] = useState(true);
  const [exit, setExit] = useState('');
  const [entry, setEntry] = useState('');
  const [exit2, setExit2] = useState('');
  const [entry2, setEntry2] = useState('');
  const [exitSelected, setExitSelected] = useState('');
  const [entrySelected, setEntrySelected] = useState('');
  const [exitSelected2, setExit2Selected] = useState('');
  const [entrySelected2, setEntry2Selected] = useState('');
  const [details, setDetails] = useState([{ '': '' }]);
  const [exitPortProcess, setExitPortProcess] = useState([{ '': '' }]);
  const [entryPortProcess, setEntryPortProcess] = useState([{ '': '' }]);
  const [detailsLoading, setDetailsLoading] = useState(true);
  const [selectincoterm, setSelectincoterm] = useState('');
  const [incotermSelected, setIncotermSelected] = useState('');
  const [incotermtext, setIncotermtext] = useState([{ '': '' }]);
  const [incotermLocation, setIncotermLocation] = useState('');
  const [products, setProducts] = useState([{ '': '' }]);
  const [selectedProduct1, setSelectedProduct1] = useState();
  const [selectedProduct2, setSelectedProduct2] = useState();
  const [selectedProduct3, setSelectedProduct3] = useState();
  const [productsLoading, setProductsLoading] = useState(true);
  const [formRows, setFormRows] = useState([]);
  const [namesOptions, setNamesOptions] = useState([]);
  const [neeOptions, setNeeOptions] = useState([]);
  const [norOptions, setNorOptions] = useState([]);
  const [loadTypeOptions, setLoadTypeOptions] = useState([]);
  const [shippingStatusOptions, setShippingStatusOptions] = useState([]);
  const [movementOptions, setMovementOptions] = useState([]);
  const [despatchCountryOptions, setDespatchCountryOptions] = useState([]);
  const [entryCountryOptions, setEntryCountryOptions] = useState([]);
  const [dualCountryOptions, setDualCountryOptions] = useState([]);
  const [exitPortOptions, setExitPortOptions] = useState([]);
  const [entryPortOptions, setEntryPortOptions] = useState([]);
  const [reportOptions, setReportOptions] = useState([]);
  const [reportParams, setReportParams] = useState([]);
  const [rolesOptions, setRolesOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [toFlagOptions, setToFlagOptions] = useState([]);
  const [fromFlagOptions, setFromFlagOptions] = useState([]);
  const [lockDirection, setLockDirection] = useState(false);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [incotermsOptions, setIncotermsOptions] = useState([]);
  const [exciseOptions, setExciseOptions] = useState([]);
  const [orderFormMovementDetails, setOrderFormMovementDetails] = useState([]);
  const [validatedRowsReadyToSubmit, setValidatedRowsReadyToSubmit] = useState([]);
  const [officeOfDest, setOfficeOfDest] = useState('');
  const [gridItems, setGridItems] = useState([{ '': '' }]);
  const [newLoadFromFile, setNewLoadFromFile] = useState(false);
  const [pasteNewLoad, setPasteNewLoad] = useState(null);
  const [newLoadFileData, setNewLoadFileData] = useState([]);
  const [tadEns, setTadEns] = useState(false);
  const [epoProgress, setEpoProgress] = useState(true);
  const [imo, setImo] = useState('');
  const [exOrImport, setExOrImport] = useState('');
  const [trailerSeal, setTrailerSeal] = useState('');
  const [transitMRN, setTransitMRN] = useState('');
  const [newLoadFileEIDR, setNewLoadFileEIDR] = useState(false);
  const [infoText, setInfoText] = useState('');
  const [isEidr, setIsEidr] = useState(false);
  const [eidrID, setEidrID] = useState('');
  const [controlledGoods, setControlledGoods] = useState('');
  const [container, setContainer] = useState('');
  const [GBimport, setGBimport] = useState(null);
  const [GBexport, setGBexport] = useState(false);
  const [RowImport, setRowImport] = useState(false);
  const [RowExport, setRowExport] = useState(false);
  const [RoiImport, setRoiImport] = useState(false);
  const [portArrivalDate, setPortArrivalDate] = useState('');
  const [portArrivalTime, setPortArrivalTime] = useState('');
  const [loadItems, setLoadItems] = useState([{ '': '' }]);
  const [importMixedPortsModal, setImportMixedPortsModal] = useState('');
  const [exportMixedPortsModal, setExportMixedPortsModal] = useState('');
  const [portsModalOptions, setPortsModalOptions] = useState([]);
  const [portsModal, setPortsModal] = useState('');
  const [exitPortDefault, setExitportdefault] = useState(false);
  const [entryPortDefault, setEntryportdefault] = useState('');
  const [loadId, setLoadId] = useState('');
  const [docTypes, setDocTypes] = useState([]);
  const [automaticRpaUploadFailed, setAutomaticRpaUploadFailed] = useState(false);
  const [adjustments, setAdjustments] = useState(generateAdjustmentsObject());
  const [VatOptions, setVatOptions] = useState([]);
  const [PreferentialOptions, setPreferentialOptions] = useState([]);
  const [newLoadID, setNewLoadID] = useState();
  const [clientID, setClientID] = useState(null);
  const [declarant, setDeclarant] = useState(null);
  const [clientIDoptions, setClientIDoptions] = useState([]);
  const [clientIDerror, setClientIDerror] = useState(null);
  const [clientIDname, setClientIDname] = useState('');
  const [clientIDEori, setClientIDEori] = useState('');
  const [clientIdAllowSAonNeeNors, setClientIdAllowSAonNeeNors] = useState(false);
  const [countryCodes, setCountryCodes] = useState([]);
  const [sdiSubmitted, setSdiSubmitted] = useState(0);
  const [sfdSubmitted, setSfdSubmitted] = useState(0);
  const [eadSubmitted, setEadSubmitted] = useState(0);
  const [epoJobRef, setEpoJobRef] = useState('');
  const [userIdSelected, setUserIdSelected] = useState(0);
  const [userReportIdSelected, setUserReportIdSelected] = useState(0);
  const [reportSelected, setReportSelected] = useState('');
  const [reportCreatedStartDate, setReportCreatedStartDate] = useState('');
  const [reportCreatedEndDate, setReportCreatedEndDate] = useState('');
  const [reportCompletedStartDate, setReportCompletedStartDate] = useState('');
  const [reportCompletedEndDate, setReportCompletedEndDate] = useState('');
  const [reportViewDeleted, setReportViewDeleted] = useState(false);
  const [reportDepartment, setReportDepartment] = useState('');
  const [reportCustomerDropdown, setReportCustomerDropdown] = useState([]);
  const [reportUser, setReportUser] = useState('');
  const [reportCustomer, setReportCustomer] = useState('');
  const [epoImport, setEpoImport] = useState();
  const [epoDirection, setEpoDirection] = useState(2);
  const [packageTotal, setPackageTotal] = useState(0);
  const [customPackageTotal, setCustomPackageTotal] = useState(0);
  const [EPOPersist, setEPOPersist] = useState({});
  const [neeNorPersist, setNeeNorPersist] = useState({});
  const [bpPersist, setBpPersist] = useState({});
  const [cabiePersist, setCabiePersist] = useState({});
  const [cabieFilters, setCabieFilters] = useState({});
  const [complianceFilters, setComplianceFilters] = useState({});
  const [epoFilters, setEpoFilters] = useState({});
  const [businessPartnerFilters, setBusinessPartnerFilters] = useState({});
  const [epoApplicationsFilters, setEpoApplicationsFilters] = useState({});
  const [neeNorFilters, setNeeNorFilters] = useState({});
  const [unmatchedDeclarationsFilters, setUnmatchedDeclarationsFilters] = useState({});
  const [ipaffsCategories, setIpaffsCategories] = useState({});
  const [certificateCount, setCertificateCount] = useState(0);
  const [ipaffsPersist, setIpaffsPersist] = useState({});
  const [orderFormMasterDataPersist, setOrderFormMasterDataPersist] = useState({});
  const [orderFormId, setOrderFormId] = useState(0);
  const [billableType, setBillableType] = useState(0);
  const [isJiraTicketRequired, setIsJiraTicketRequired] = useState(false);
  const [dutyRates, setDutyRates] = useState([]);
  const [exchangeRate, setExchangeRate] = useState(null);
  const [qTracesChed, setQTracesChed] = useState(0);
  const [QAProductsList, setQAProductsList] = useState([]);
  const [customsMoPConfirmation, setCustomsMoPConfirmation] = useState({ confirmed: false, selection: null });
  const [customsMopValue, setCustomsMopValue] = useState('');
  const [newLoadParent, setNewLoadParent] = useState({ parentId: null, parentName: '', parentEori: '' });
  const [newLoadDataModified, setNewLoadDataModified] = useState(false);
  const [newLoadItemsModified, setNewLoadItemsModified] = useState(false);
  const [preferenceData, setPreferenceData] = useState([]);
  const [totalItemValue, setTotalItemValue] = useState(0);
  const [totalItemCustomsValue, setTotalItemCustomsValue] = useState(0);
  const [eidrAdjustments, setEidrAdjustments] = useState(null);
  const [processedRpaId, setProcessedRpaId] = useState(null);
  const [importFileData, setImportFileData] = useState(null);
  const [companyID, setCompanyID] = useState(null);

  const [QAConsigneeData, setQAConsigneeData] = useState({
    cabieStatus: '',
    cabieStatusValid: true,
    consignee: '',
    dbStatus: '',
    dbStatusValid: true,
    eori: '',
    id: null,
    standingAuthority: '',
    standingAuthorityValid: true,
  });

  const [QAConsignorData, setQAConsignorData] = useState({
    cabieStatus: '',
    cabieStatusValid: true,
    consignor: '',
    dbStatus: '',
    dbStatusValid: true,
    eori: '',
    id: null,
    standingAuthority: '',
    standingAuthorityValid: true,
  });

  const [QACustomerData, setQACustomerData] = useState({
    billableCustomer: '',
    billableCustomerValid: true,
    cabieStatus: '',
    cabieStatusValid: true,
    cm8Approved: '',
    cm8ApprovedValid: true,
    companyName: '',
    dbStatus: '',
    dbStatusValid: true,
    eori: '',
    id: null,
  });
  const [representative, setRepresentative] = useState(false);
  const [isResetLoadTriggered, setIsResetLoadTriggered] = useState(false);
  const [QAPreferenceClaimOptions, setQAPreferenceClaimOptions] = useState([]);
  const [multipleConsignors, setMultipleConsignors] = useState(false);
  const [multipleInvoices, setMultipleInvoices] = useState(false);
  const [multipleConsignorDetails, setMultipleConsignorDetails] = useState({}); // caches details of consignors for use on Items and QA screen
  const [isMultipleInvoicesValid, setIsMultipleInvoicesValid] = useState(false);
  const [isMultipleConsignorsValid, setIsMultipleConsignorsValid] = useState(false);
  const [exchangeRateCache, setExchangeRateCache] = useState({});

  const [ffd, setFfd] = useState(false);

  // when set to true, the maintenance banner details should refresh
  const [maintenanceRefresh, setMaintenanceRefresh] = useState(false);

  const resetUserIdSelected = () => {
    setUserIdSelected(0);
  };

  const resetUserReportIdSelected = () => {
    setUserReportIdSelected(0);
  };

  const resetNewLoad = () => {
    setIsResetLoadTriggered(true);
    setDirectionSelected('');
    setTrailerSeal('');
    setSelectName('');
    setExitPortProcess('');
    setEntryCountryOptions([]);
    setEntryPortProcess('');
    setExit('');
    setDespatchCountryOptions([]);
    setEntry('');
    setSelectName('');
    setSelectFcl('');
    setTruck('');
    setIncotermLocation('');
    setdate('');
    setDespatch('');
    setDestination('');
    setExitSelected('');
    setExit2Selected('');
    setExit2('');
    setEntrySelected('');
    setEntry2Selected('');
    setEntry2('');
    setConsignor('');
    setJobRef('');
    setJiraTicket('');
    setPortalRef('');
    setLoadTypeDescription('');
    setConsignee('');
    setConsigneeRPA('');
    setConsignorRPA('');
    setInvoicenumber('');
    setPoNumber('');
    setInvoicecurr('');
    setSelectincoterm('');
    setShipStatus('');
    setTrailer('');
    setFormRows([]);
    setOfficeOfDest('');
    setPasteNewLoad(true);
    setValidatedRowsReadyToSubmit([]);
    setGridItems([]);
    setNewLoadFromFile(false);
    setNewLoadFileData([]);
    setTadEns(false);
    setImo('');
    setIsEidr(false);
    setEidrID('');
    setControlledGoods(false);
    setContainer('');
    setGBimport(null);
    setGBexport(false);
    setExportMixedPortsModal('');
    setImportMixedPortsModal('');
    setPortsModalOptions([]);
    setPortsModal('');
    setExitportdefault('');
    setEntryportdefault('');
    setLoadId('');
    setDocTypes([]);
    setAutomaticRpaUploadFailed(false);
    setPackageTotal(0);
    setCustomPackageTotal(0);
    setAdjustments(generateAdjustmentsObject());
    setClientID(null);
    setClientIDEori(null);
    setClientIDerror(null);
    setClientIDname('');
    setClientIdAllowSAonNeeNors(false);
    setDeclarant(null);
    setTransitMRN('');
    setRepresentative(false);
    setQAProductsList([]);
    setIsJiraTicketRequired(false);
    setCustomsMoPConfirmation({ confirmed: false, selection: null });
    setNewLoadParent({ parentId: null, parentName: '', parentEori: '' });
    setQTracesChed(0);
    setMultipleConsignors(false);
    setMultipleInvoices(false);
    setMultipleConsignorDetails({});
    setLoadStatus('');
    setNewLoadDataModified(false);
    setNewLoadItemsModified(false);
    setPreferenceData([]);
    setTotalItemValue(0);
    setTotalItemCustomsValue(0);
    setEidrAdjustments(null);
    setExchangeRate(null);
    setEntryPortOptions([]);
    setExitPortOptions([]);
    setProcessedRpaId(null);
    setImportFileData(null);
    setIpaffsCategories({});
    setCertificateCount(0);
  };

  const updateNewLoadState = (value, setter) => {
    setNewLoadDataModified(true);
    setter(value);
  };

  const updateParentAndLoadDefaults = async (parentData) => {
    setNewLoadParent(parentData);

    if (parentData?.parentId) {
      try {
        const data = await getBusinessPartnerDefaults(parentData.parentId);
        const {
          movementTypeId,
          loadTypeId,
          countryidDespatch,
          countryidDestination,
          portModelId,
          exit1Portid,
          entry1Portid,
          shipStatus: shipStatusDefault,
          trailerNo,
          container: containerDefault,
        } = data;

        !directionSelected && setDirectionSelected(movementTypeId);
        !selectFcl && setSelectFcl(loadTypeId);
        !despatch && setDespatch(countryidDespatch);
        !destination && setDestination(countryidDestination);
        !portsModal && setPortsModal(portModelId);
        !exit && setExit(exit1Portid);
        !entry && setEntry(entry1Portid);
        !shipStatus && setShipStatus(shipStatusDefault);
        !truck && setTruck(trailerNo);
        !container && setContainer(containerDefault);
      } catch (error) {
        console.error('unable to load defaults');
        console.error('error: ', error);
      }
    }
  };

  const store = {
    resetUserIdSelected,
    resetUserReportIdSelected,
    resetNewLoad,
    requestFailed: [requestFailed, setRequestFailed],
    saved: [saved, setSaved],
    selectName: [selectName, setSelectName],
    selectFcl: [selectFcl, setSelectFcl],
    truck: [truck, setTruck],
    trailer: [trailer, setTrailer],
    shipStatus: [shipStatus, setShipStatus],
    date: [date, setdate],
    jobRef: [jobRef, setJobRef],
    jiraTicket: [jiraTicket, setJiraTicket],
    portalRef: [portalRef, setPortalRef],
    loadTypeDescription: [loadTypeDescription, setLoadTypeDescription],
    loadStatus: [loadStatus, setLoadStatus],
    consignor: [consignor, setConsignor],
    consignee: [consignee, setConsignee],
    consignorRPA: [consignorRPA, setConsignorRPA],
    consigneeRPA: [consigneeRPA, setConsigneeRPA],
    invoicenumber: [invoicenumber, setInvoicenumber],
    poNumber: [poNumber, setPoNumber],
    invoicecurr: [invoicecurr, setInvoicecurr],
    directionLoading: [directionLoading, setDirectionLoading],
    direction: [direction, setDirection],
    despatch: [despatch, setDespatch],
    destination: [destination, setDestination],
    directionSelected: [directionSelected, setDirectionSelected],
    destinationSelected: [destinationSelected, setDestinationSelected],
    despatchSelected: [despatchSelected, setDespatchSelected],
    despatchLoading: [despatchLoading, setDespatchLoading],
    destinationLoading: [destinationLoading, setDestinationLoading],
    exitLoading: [exitLoading, setExitLoading],
    entryLoading: [entryLoading, setEntryLoading],
    incotermLoading: [incotermLoading, setIncotermLoading],
    exit: [exit, setExit],
    entry: [entry, setEntry],
    exit2: [exit2, setExit2],
    entry2: [entry2, setEntry2],
    exitSelected: [exitSelected, setExitSelected],
    entrySelected: [entrySelected, setEntrySelected],
    exitSelected2: [exitSelected2, setExit2Selected],
    entrySelected2: [entrySelected2, setEntry2Selected],
    details: [details, setDetails],
    exitPortProcess: [exitPortProcess, setExitPortProcess],
    entryPortProcess: [entryPortProcess, setEntryPortProcess],
    detailsLoading: [detailsLoading, setDetailsLoading],
    selectincoterm: [selectincoterm, setSelectincoterm],
    incotermSelected: [incotermSelected, setIncotermSelected],
    incotermtext: [incotermtext, setIncotermtext],
    incotermLocation: [incotermLocation, setIncotermLocation],
    products: [products, setProducts],
    selectedProduct1: [selectedProduct1, setSelectedProduct1],
    selectedProduct2: [selectedProduct2, setSelectedProduct2],
    selectedProduct3: [selectedProduct3, setSelectedProduct3],
    productsLoading: [productsLoading, setProductsLoading],
    storeTest: [storeTest, setStoreTest],
    formRows: [formRows, setFormRows],
    namesOptions: [namesOptions, setNamesOptions],
    neeOptions: [neeOptions, setNeeOptions],
    norOptions: [norOptions, setNorOptions],
    loadTypeOptions: [loadTypeOptions, setLoadTypeOptions],
    shippingStatusOptions: [shippingStatusOptions, setShippingStatusOptions],
    movementOptions: [movementOptions, setMovementOptions],
    despatchCountryOptions: [despatchCountryOptions, setDespatchCountryOptions],
    entryCountryOptions: [entryCountryOptions, setEntryCountryOptions],
    dualCountryOptions: [dualCountryOptions, setDualCountryOptions],
    exitPortOptions: [exitPortOptions, setExitPortOptions],
    entryPortOptions: [entryPortOptions, setEntryPortOptions],
    reportOptions: [reportOptions, setReportOptions],
    reportParams: [reportParams, setReportParams],
    rolesOptions: [rolesOptions, setRolesOptions],
    userOptions: [userOptions, setUserOptions],
    currencyOptions: [currencyOptions, setCurrencyOptions],
    toFlagOptions: [toFlagOptions, setToFlagOptions],
    fromFlagOptions: [fromFlagOptions, setFromFlagOptions],
    exOrImport: [exOrImport, setExOrImport],
    lockDirection: [lockDirection, setLockDirection],
    incotermsOptions: [incotermsOptions, setIncotermsOptions],
    exciseOptions: [exciseOptions, setExciseOptions],
    orderFormMovementDetails: [orderFormMovementDetails, setOrderFormMovementDetails],
    validatedRowsReadyToSubmit: [validatedRowsReadyToSubmit, setValidatedRowsReadyToSubmit],
    officeOfDest: [officeOfDest, setOfficeOfDest],
    gridItems: [gridItems, setGridItems],
    newLoadFromFile: [newLoadFromFile, setNewLoadFromFile],
    pasteNewLoad: [pasteNewLoad, setPasteNewLoad],
    newLoadFileData: [newLoadFileData, setNewLoadFileData],
    tadEns: [tadEns, setTadEns],
    epoProgress: [epoProgress, setEpoProgress],
    imo: [imo, setImo],
    newLoadFileEIDR: [newLoadFileEIDR, setNewLoadFileEIDR],
    infoText: [infoText, setInfoText],
    isEidr: [isEidr, setIsEidr],
    eidrID: [eidrID, setEidrID],
    controlledGoods: [controlledGoods, setControlledGoods],
    container: [container, setContainer],
    GBimport: [GBimport, setGBimport],
    GBexport: [GBexport, setGBexport],
    RowExport: [RowExport, setRowExport],
    RowImport: [RowImport, setRowImport],
    RoiImport: [RoiImport, setRoiImport],
    portArrivalDate: [portArrivalDate, setPortArrivalDate],
    portArrivalTime: [portArrivalTime, setPortArrivalTime],
    loadItems: [loadItems, setLoadItems],
    exportMixedPortsModal: [exportMixedPortsModal, setExportMixedPortsModal],
    importMixedPortsModal: [importMixedPortsModal, setImportMixedPortsModal],
    portsModal: [portsModal, setPortsModal],
    portsModalOptions: [portsModalOptions, setPortsModalOptions],
    exitPortDefault: [exitPortDefault, setExitportdefault],
    entryPortDefault: [entryPortDefault, setEntryportdefault],
    loadId: [loadId, setLoadId],
    docTypes: [docTypes, setDocTypes],
    automaticRpaUploadFailed: [automaticRpaUploadFailed, setAutomaticRpaUploadFailed],
    adjustments: [adjustments, setAdjustments],
    newLoadID: [newLoadID, setNewLoadID],
    VatOptions: [VatOptions, setVatOptions],
    PreferentialOptions: [PreferentialOptions, setPreferentialOptions],
    clientID: [clientID, setClientID],
    companyID: [companyID, setCompanyID],
    clientIDoptions: [clientIDoptions, setClientIDoptions],
    clientIDerror: [clientIDerror, setClientIDerror],
    clientIDname: [clientIDname, setClientIDname],
    clientIDEori: [clientIDEori, setClientIDEori],
    clientIdAllowSAonNeeNors: [clientIdAllowSAonNeeNors, setClientIdAllowSAonNeeNors],
    declarant: [declarant, setDeclarant],
    countryCodes: [countryCodes, setCountryCodes],
    sdiSubmitted: [sdiSubmitted, setSdiSubmitted],
    sfdSubmitted: [sfdSubmitted, setSfdSubmitted],
    eadSubmitted: [eadSubmitted, setEadSubmitted],
    epoJobRef: [epoJobRef, setEpoJobRef],
    userIdSelected: [userIdSelected, setUserIdSelected],
    userReportIdSelected: [userReportIdSelected, setUserReportIdSelected],
    reportSelected: [reportSelected, setReportSelected],
    reportCreatedStartDate: [reportCreatedStartDate, setReportCreatedStartDate],
    reportCreatedEndDate: [reportCreatedEndDate, setReportCreatedEndDate],
    reportCompletedStartDate: [reportCompletedStartDate, setReportCompletedStartDate],
    reportCompletedEndDate: [reportCompletedEndDate, setReportCompletedEndDate],
    reportViewDeleted: [reportViewDeleted, setReportViewDeleted],
    reportDepartment: [reportDepartment, setReportDepartment],
    reportCustomerDropdown: [reportCustomerDropdown, setReportCustomerDropdown],
    reportUser: [reportUser, setReportUser],
    reportCustomer: [reportCustomer, setReportCustomer],
    epoImport: [epoImport, setEpoImport],
    epoDirection: [epoDirection, setEpoDirection],
    packageTotal: [packageTotal, setPackageTotal],
    customPackageTotal: [customPackageTotal, setCustomPackageTotal],
    EPOPersist: [EPOPersist, setEPOPersist],
    bpPersist: [bpPersist, setBpPersist],
    cabiePersist: [cabiePersist, setCabiePersist],
    cabieFilters: [cabieFilters, setCabieFilters],
    complianceFilters: [complianceFilters, setComplianceFilters],
    epoFilters: [epoFilters, setEpoFilters],
    businessPartnerFilters: [businessPartnerFilters, setBusinessPartnerFilters],
    epoApplicationsFilters: [epoApplicationsFilters, setEpoApplicationsFilters],
    neeNorFilters: [neeNorFilters, setNeeNorFilters],
    unmatchedDeclarationsFilters: [unmatchedDeclarationsFilters, setUnmatchedDeclarationsFilters],
    neeNorPersist: [neeNorPersist, setNeeNorPersist],
    ipaffsPersist: [ipaffsPersist, setIpaffsPersist],
    orderFormMasterDataPersist: [orderFormMasterDataPersist, setOrderFormMasterDataPersist],
    trailerSeal: [trailerSeal, setTrailerSeal],
    transitMRN: [transitMRN, setTransitMRN],
    ffd: [ffd, setFfd],
    QAConsigneeData: [QAConsigneeData, setQAConsigneeData],
    QAConsignorData: [QAConsignorData, setQAConsignorData],
    QACustomerData: [QACustomerData, setQACustomerData],
    representative: [representative, setRepresentative],
    ipaffsCategories: [ipaffsCategories, setIpaffsCategories],
    certificateCount: [certificateCount, setCertificateCount],
    preferenceData: [preferenceData, setPreferenceData],
    totalItemValue: [totalItemValue, setTotalItemValue],
    totalItemCustomsValue: [totalItemCustomsValue, setTotalItemCustomsValue],
    eidrAdjustments: [eidrAdjustments, setEidrAdjustments],
    maintenanceRefresh: [maintenanceRefresh, setMaintenanceRefresh],
    orderFormId: [orderFormId, setOrderFormId],
    billableType: [billableType, setBillableType],
    isJiraTicketRequired: [isJiraTicketRequired, setIsJiraTicketRequired],
    dutyRates: [dutyRates, setDutyRates],
    exchangeRate: [exchangeRate, setExchangeRate],
    qTracesChed: [qTracesChed, setQTracesChed],
    QAProductsList: [QAProductsList, setQAProductsList],
    customsMoPConfirmation: [customsMoPConfirmation, setCustomsMoPConfirmation],
    customsMopValue: [customsMopValue, setCustomsMopValue],
    newLoadParent: [newLoadParent, setNewLoadParent],
    updateParentAndLoadDefaults,
    isResetLoadTriggered: [isResetLoadTriggered, setIsResetLoadTriggered],
    newLoadDataModified: [newLoadDataModified, setNewLoadDataModified],
    QAPreferenceClaimOptions: [QAPreferenceClaimOptions, setQAPreferenceClaimOptions],
    newLoadItemsModified: [newLoadItemsModified, setNewLoadItemsModified],
    multipleConsignors: [multipleConsignors, setMultipleConsignors],
    multipleInvoices: [multipleInvoices, setMultipleInvoices],
    multipleConsignorDetails: [multipleConsignorDetails, setMultipleConsignorDetails],
    isMultipleInvoicesValid: [isMultipleInvoicesValid, setIsMultipleInvoicesValid],
    isMultipleConsignorsValid: [isMultipleConsignorsValid, setIsMultipleConsignorsValid],
    exchangeRateCache: [exchangeRateCache, setExchangeRateCache],
    processedRpaId: [processedRpaId, setProcessedRpaId],
    importFileData: [importFileData, setImportFileData],
    updateNewLoadState,
  };

  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
};

export default StoreProvider;
